//const CLINIC_DEFAULT_URL = 'https://www.tuttnauer-connect.com/clinic';
export const CLINIC_DEFAULT_URL = 'https://tconnect.tuttnauer.com/clinic';
